import FeatureController from '../FeatureController';

export default class EditController extends FeatureController {

    constructor (panel, $state) {
      super(panel, $state);

      this.profile = {};
      this.register = {};
      this.match = {};
      this.age_range = this.panel.range(17, 100);
      this.date = '1990-01-01';
      const self = this;

      this.panel.get('/v1/profile/' + this.user.screen_name, (response) => {
        if (self.panel.okay(response)) {
          for (let i in response) {
            if (i !== 'data') {
              self[i] = response[i];
            } else {
              for (let j in response.data) {
                self[j] = response.data[j];
              }
            }
          }
          for (let i in self.profile) {
            if (isset(self.options[i])) {
              self.profile[i] = self.options[i][0].id;
            }
          }
        }
      });
    }

    redirectUrl (url) {
        history.pushState(null, null, url);
    }

    update_profile (redirectUrl) {
        redirectUrl = isset(redirectUrl) ? redirectUrl : '/profile/'+this.user.screen_name;
        let birthday = $("#birthday").val();

        if (birthday !== '') {
            let year = new Date().getFullYear();
            let birth_year = parseInt(birthday.substring(0,4));

            if (year - birth_year < 17) {
                this.panel.alert("Invalid age. You must be at least +17 years old.");
                return;
            }
            this.profile.birthday = birthday;
        }

        let data = {profile:this.profile};

        const self = this;

        this.panel.post('/v1/update/profile', data, (response) => {
            if (self.panel.okay(response)) {
              self.panel.setHasCompletedProfile(true);
              self.redirectUrl(redirectUrl);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/edit-profile/EditProfileController.js